import moment from 'moment';

export default {
  props: {
    appointment: {
      type: Object,
      required: true,
    },

    edit: {
      type: Function,
      required: false,
    },

    fade: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getTimeRange(appointment) {
      const start = moment(appointment.start, 'DD/MM/YYYY HH:mm').format('HH:mm');
      const end = moment(appointment.start, 'DD/MM/YYYY HH:mm')
      .add(appointment.duration, 'minute').format('HH:mm');

      return `${start} - ${end}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/appointmentCard/appointmentCard.js